// @ts-nocheck
import React, { useEffect } from "react";
// import { Typography } from "antd";
import { Copy, Download } from "assets/images";
import { BackendLog, getLogs, getLogsFile } from "store/reducers/LogsSlice";
import { Box, StyledTable } from "./historyTableStyles";
import { useDispatch } from "react-redux";
import { handleCopy } from "utils/copyText";
import { useAppSelector } from "hooks/redux";
import Loader from "../Loader/Loader";
import { downloadLogsFile } from "store/reducers/SettingsSlice";


interface IColumns {
    title: string;
    dataIndex: string;
    key: string;
    render?: (text: any, record: BackendLog) => JSX.Element;
}

function HistoryTable() {
    const dispatch = useDispatch();
    const { loading, logs } = useAppSelector((state) => state.logs || {});
    const { results = [], count = 0 } = logs || {};
    // const [testResults, setTestResults] = useState<BackendLog[]>([]);

    useEffect(() => {
        dispatch(getLogs());
    }, [dispatch]);

    // useEffect(() => {
    //     if (!results) return;
    //     setTestResults([
    //         // {
    //         //     id: 1,
    //         //     ticker_name: "string",
    //         //     owner: "admin",
    //         //     run_date: "2021-11-26",
    //         //     status: "Done",
    //         //     link: "D:/someCoolLink2",
    //         //     size: null,
    //         // },
    //         // {
    //         //     id: 2,
    //         //     ticker_name: "string",
    //         //     owner: "admin",
    //         //     run_date: "2021-11-26",
    //         //     status: "Done",
    //         //     link: "D:/someCoolLink2",
    //         //     size: null,
    //         // },
    //         // {
    //         //     id: 555,
    //         //     ticker_name: "string",
    //         //     owner: "admin",
    //         //     run_date: "2021-11-26",
    //         //     status: "Error",
    //         //     link: null,
    //         //     size: null,
    //         // },
    //         ...results,
    //     ]);
    // }, [results]);

    const handleDownloadFile = (link: string) => {
        dispatch(
            downloadLogsFile({
                link,
            })
        );
    };

    const onPageChange = (page: number) => {
        dispatch(getLogs(page));
    };

    const columns: IColumns[] = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Статус",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Дата запуска",
            dataIndex: "run_date",
            key: "run_date",
            render: (_, { run_date }) => (
                <Box>
                    {new Intl.DateTimeFormat("ru-RU").format(
                        new Date(run_date)
                    )}{" "}
                    {new Intl.DateTimeFormat("ru-RU", {
                        hour: "2-digit",
                        minute: "2-digit",
                    }).format(new Date(run_date))}
                </Box>
            ),
        },
        {
            title: "Кто запустил",
            dataIndex: "owner",
            key: "owner",
        },
        {
            title: "",
            dataIndex: "buttons",
            key: "buttons",
            render: (_, { link, id, status }) => (
                <Box>
                    {status === "Done" && (
                        <>
                            <Copy
                                title={link}
                                onClick={() =>
                                    handleCopy(link === null ? "" : link)
                                }
                            />
                            <Download
                                onClick={() => handleDownloadFile(link)}
                            />
                            {/*<Link href="customproto://C:/Dima/PowerOfTwo/text.txt" target="_blank">*/}
                            {/*    <OpenInNew/>*/}
                            {/*</Link>*/}
                        </>
                    )}
                </Box>
            ),
        },
    ];

    const tableLoading = {
        spinning: loading,
        indicator: <Loader size="large" />,
    };

    return (
        <StyledTable
            dataSource={results}
            loading={tableLoading}
            columns={columns}
            bordered
            pagination={{
                total: count,
                pageSize: 20,
                onChange: onPageChange,
            }}
        />
    );
}

export default HistoryTable;
